export default "__VITE_ASSET__BEhlA0lV__"